export default __webpack_public_path__ + "static/media/Belle 9781408308103.5e18de79.jpg";